import { SITE_VARIABLES } from '../../../../common/styles/variables';

interface StylesObject {
  titleWrapperStyle: { [key: string]: any };
  titleStyle: { [key: string]: any };
  upNextTitleStyle: { [key: string]: any };
}

const titleFontFamily = SITE_VARIABLES.TEXT_FONT_FAMILY.LATO;
const titleColor = SITE_VARIABLES.COLORS.WHITE;

const titleWrapper = {
  bigNextVideo: {
    marginLeft: '6px',
    marginBottom: '4px',
  },
  smallNextVideo: {
    marginLeft: '4px',
  },
};

const title = {
  fontFamily: titleFontFamily,
  fontWeight: '300',
  fontSize: '11px',
  color: titleColor,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  display: 'block',
  maxWidth: '153px',
  height: '14px',
  lineHeight: '14px',
};

const upNextTitle = {
  ...title,
  fontWeight: '400',
  bottom: '18px',
  marginRight: '0px',
};

export const getTitleStyleObject = (smallNextVideo: boolean): StylesObject => ({
  titleStyle: {
    ...title,
  },
  upNextTitleStyle: {
    ...upNextTitle,
  },
  titleWrapperStyle: [
    !smallNextVideo && titleWrapper.bigNextVideo,
    titleWrapper.smallNextVideo,
  ],
});
